import React from 'react';
import * as ReactDOM from 'react-dom';
import { ExtensionProvider } from '../components/ExtensionProvider.component';
import { JRC404 } from 'jamespot-react-components';
import { useRoutes, unstable_HistoryRouter as HistoryRouter, Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import { BrowserHistory, createBrowserHistory } from 'history';

export const ReactRouterHistory = createBrowserHistory({ window });

export interface ReactRouter {
    history: BrowserHistory;
    routes: RouteObject[];
    routesNG: RouteObject[];
    addRoute: (route: RouteObject, ng?: boolean, isPublic?: boolean) => { route: string } | null;
    init: (idDiv: string) => void;
}

const BASE_PATH_NG = '/ng/rr';
const BASE_PATH_REACT = '/r';

const Routes = () => {
    const routesObject: RouteObject[] = [
        {
            path: BASE_PATH_NG,
            children: [...J.react.router.routesNG],
        },
        {
            path: BASE_PATH_REACT,
            children: [...J.react.router.routes],
        },
        { path: BASE_PATH_NG + '/404', element: <JRC404 /> },
        { path: BASE_PATH_REACT + '/404', element: <JRC404 /> },
        { path: '*', element: <Navigate to={(J.reactLayout ? BASE_PATH_REACT : BASE_PATH_NG) + '/404'} replace /> },
    ];
    return useRoutes(routesObject);
};

class Router implements ReactRouter {
    history: BrowserHistory;
    routes: RouteObject[] = [];
    routesNG: RouteObject[] = [];

    constructor(history: BrowserHistory) {
        this.history = history;
    }

    addRoute = (route: RouteObject, ng = true, isPublic = false) => {
        const addRoute = !isPublic && J.jUserCurrent ? true : isPublic;
        if (!addRoute) {
            return null;
        }

        if (ng) {
            this.routesNG.push(route);
        } else {
            this.routes.push(route);
        }

        return {
            route: (ng ? BASE_PATH_NG : BASE_PATH_REACT) + '/' + route.path,
        };
    };

    init = (idDiv: string) => {
        /**
         * Add current url to ReactRouterHistory
         */
        if (
            ReactRouterHistory.location.pathname !== window.location.pathname ||
            ReactRouterHistory.location.search !== window.location.search
        ) {
            ReactRouterHistory.push({ pathname: window.location.pathname, search: window.location.search });
        }

        ReactDOM.render(
            <ExtensionProvider layout={J.reactLayout}>
                <HistoryRouter history={ReactRouterHistory as any}>
                    <Routes />
                </HistoryRouter>
            </ExtensionProvider>,
            document.getElementById(idDiv),
        );
    };
}

const router = new Router(ReactRouterHistory);

export default router;
